import * as React from "react";
import { useHost } from "@xingternal/crate-core-runtime-helper";
import { useFeatureSwitches } from "@xingternal/crate-hooks-use-feature-switches";
import { useIsDesktop } from "@xingternal/crate-hooks-use-is-desktop";
import { useLoginState } from "@xingternal/crate-hooks-use-login-state";
import { useFrameHooks } from "@xingternal/hub";
import { checkArmstrongCookie } from "./conditional-routes-cookie-helper";
import { ArmstrongDesktopPage, NoAccessPage } from "./error-components";
import { LayoutSwitcher } from "./layout-switcher";
import { PageViewTracker } from "./page-view-tracker/page-view-tracker";
import { getRedirectionUrl } from "./redirect-handlers/redirect-handler";
import { Zerofier } from "./zerofier";
const Route = ({ data, setActiveItem }) => {
  var _a;
  const isDesktop = useIsDesktop();
  const [wasDesktopAtPageLoad] = React.useState(isDesktop);
  const loginState = useLoginState();
  const { XingletLoader, redirectToLogin } = useHost();
  const {
    layout,
    activeItem,
    visibleTo,
    xinglet: xingletName,
    pageName,
    trackingChannel
  } = data;
  React.useEffect(() => {
    setActiveItem(activeItem);
  }, [activeItem, setActiveItem]);
  const { hasCookie, isArmstrongUser } = checkArmstrongCookie();
  const armstrongV1 = useFeatureSwitches(["armstrong_v1"]);
  const WINDOWS_USER_AGENT = "XING-Windows-Universal";
  const currentUserAgent = ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) || "";
  const isWindows = currentUserAgent.includes(WINDOWS_USER_AGENT);
  const { useExperiment } = useFrameHooks();
  const testCase = useExperiment(visibleTo.bigScreenExperiment);
  const isInBigScreenExperiment = testCase === "B";
  const isInBigScreenFeatureSwitch = useFeatureSwitches([
    visibleTo.bigScreenFeatureSwitch || "this is not a feature switch, just here because the hook can not be called conditionally"
  ]);
  if (loginState.isLoggedOut && !visibleTo.loggedOut)
    return redirectToLogin();
  if (loginState.isSoftLoggedIn && !visibleTo.softLoggedIn)
    return redirectToLogin();
  if (!visibleTo.loggedIn && !visibleTo.loggedOut)
    return /* @__PURE__ */ React.createElement(NoAccessPage, null);
  if (loginState.isLoggedIn && !visibleTo.loggedIn)
    return /* @__PURE__ */ React.createElement(NoAccessPage, null);
  if (!armstrongV1 && !visibleTo.nonArmstrongUser || isWindows || wasDesktopAtPageLoad && !visibleTo.bigScreenUser && !isInBigScreenExperiment && !isInBigScreenFeatureSwitch || hasCookie && !isArmstrongUser && !visibleTo.nonArmstrongUser) {
    const redirectUrl = getRedirectionUrl(`${window.location.pathname}${window.location.search}`, window.location.origin);
    if (redirectUrl) {
      window.location.replace(redirectUrl.replace(/xing.test=integration/, ""));
      return null;
    }
  }
  if (!armstrongV1 && !visibleTo.nonArmstrongUser)
    return /* @__PURE__ */ React.createElement(NoAccessPage, null);
  if (isDesktop && !visibleTo.bigScreenUser && !isInBigScreenExperiment && !isInBigScreenFeatureSwitch) {
    return /* @__PURE__ */ React.createElement(ArmstrongDesktopPage, null);
  }
  return /* @__PURE__ */ React.createElement(LayoutSwitcher, {
    ...{ layout, loginState }
  }, /* @__PURE__ */ React.createElement(PageViewTracker, {
    pageName,
    trackingChannel
  }), /* @__PURE__ */ React.createElement(Zerofier, {
    activeItem
  }), /* @__PURE__ */ React.createElement(XingletLoader, {
    name: xingletName,
    key: xingletName
  }));
};
export {
  Route
};
